import { render } from "./bothSide.vue?vue&type=template&id=325c3eba&scoped=true"
import script from "./bothSide.vue?vue&type=script&lang=js"
export * from "./bothSide.vue?vue&type=script&lang=js"

import "./bothSide.vue?vue&type=style&index=0&id=325c3eba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325c3eba"]])

export default __exports__